<template>
  <v-menu v-model="menu" :close-on-click="false" :close-on-content-click="true">
    <template v-slot:activator="{ on, attrs }">
      <v-chip
        :close="!disabled"
        outlined
        v-on="on"
        v-bind="attrs"
        @click="
          menu = selected == null ? true : true;
          $emit('update:selected', selected == null ? index : null);
        "
        @keyup.enter="
          menu = selected == null ? true : true;
          $emit('update:selected', selected == null ? index : null);
        "
        @click:close="$emit('delete', index)"
      >
        {{ items[index] }}
      </v-chip>
    </template>
    <validation-provider
      ref="prov"
      id="item"
      :name="$t('stbserial')"
      :rules="'required|stbserial'"
      v-slot="{ errors, classes, valid }"
    >
      <v-card width="350">
        <v-card-text>
          <v-text-field
            v-model="value"
            name="stbserial"
            :label="$t('stbserial')"
            :placeholder="$t('new number')"
            :error-messages="errors"
            :class="classes"
            :maxlength="
              maxLength != null && maxLength != ''
                ? maxLength - currentLength
                : ''
            "
            :counter="
              maxLength != null && maxLength != ''
                ? maxLength - currentLength
                : ''
            "
            @click.stop=""
            @keyup.enter="valid && $emit('commit', value)"
            :clearable="!isMobile"
            flat
            solo
            autofocus
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="$emit('unselect', index)">
            {{ $t("discard") }}
          </v-btn>
          <v-btn
            color="primary"
            :disabled="!valid"
            @click="$emit('commit', value)"
            text
          >
            {{ $t("change") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-provider>
  </v-menu>
</template>

<script>
import isMobile from "@/utils/mixins/isMobile";

export default {
  name: "TvListInputChip",
  mixins: [isMobile],
  props: {
    index: {
      type: Number,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    maxLength: {
      validator: (prop) =>
        typeof prop === "string" || typeof prop === "number" || prop === null,
      required: true,
      default: null,
    },
    selected: {
      default: null,
      required: true,
    },
    disabled: {
      default: false,
      required: false,
    },
  },
  data: () => ({
    value: "",
    menu: false,
  }),
  computed: {
    active() {
      return this.selected == this.index;
    },
    currentLength() {
      this.index;
      var that = this;
      return this.items
        .filter(function (e, index) {
          return that.index == null || that.index != index;
        })
        .join(this.separator).length;
    },
  },
  watch: {
    items: {
      immediate: true,
      handler(value) {
        this.value = value[this.index] || "";
      },
    },
    selected: {
      immediate: true,
      handler(value) {
        this.menu = this.active;
      },
    },
    menu(value) {
      if (!value) this.$emit("update:selected", null);
    },
  },
  methods: {},
};
</script>

<i18n>
{
  "en": {
    "stbserial": "Set-Top Box Serial Number",
    "new number": "New number",
    "discard": "Discard",
    "change": "Change"
  },
  "de": {
    "stbserial": "Set-Top Box Seriennummer",
    "new number": "Neue Nummer",
    "discard": "Verwerfen",
    "change": "Ändern"
  }
}
</i18n>
